import { Grid, Paper, Typography } from "@material-ui/core";
import React from "react";

const BoxVideo = (props) => {
  let { ModelID, naam, FabrikantOmschrijving, FabrikantNummer } = props.data;
  const { history } = props;

  ModelID = Number(ModelID);

  return (
    <Paper
      elevation={2}
      style={{ cursor: "pointer" }}
      onClick={() => history.push("/Overview/Video/" + ModelID)}
    >
      <Grid container justify="space-between">
        <Grid item xs={3}>
          <img
            src={`/media/Video's/video-${ModelID}/voorkant.jpg`}
            // + new Date().getTime();
            style={{
              maxWidth: "calc(97% - 8px)",
              marginLeft: 4,
              marginTop: 4,
              borderRadius: 7,
              border: "black 1px solid",
            }}
            alt={"Afbeelding van een Unimog."}
            onError={(e) => {
              e.target.onError = null;
              e.target.src =
                "/media/Model_images/Placeholder.jpg";
            }}
          ></img>
        </Grid>
        <Grid item xs={9} container justify="space-around" alignItems="stretch">
          <Grid item xs={12}>
            <Typography noWrap style={{ fontSize: "120%" }}>
              {naam}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography noWrap style={{ fontSize: "120%" }}>
              {FabrikantOmschrijving}
            </Typography>
          </Grid>
          <Grid item container xs={12}>
            <Grid item xs={8}>
              <Typography noWrap style={{ fontSize: "120%" }}>
                {FabrikantNummer}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default BoxVideo;
